import React, { useEffect, useState } from "react";
import PageBreadcrumb from "../../components/common/CustomBreadCrumb";
import ComponentCard from "../../components/common/ComponentCard";
import PageMeta from "../../components/common/PageMeta";
import Input from "../../components/form/input/InputField";
import { Search } from "lucide-react";
import CategoryTable from "@/components/tables/CategoryTable";
import NotificationService from "@/services/notification.service";
import { useTranslation } from "react-i18next";
import NotificationHistoryTable from "@/components/tables/NotificationHistoryTable";

export default function ListNotificationHistories() {
    const { t } = useTranslation();
    const [params, setParams] = useState({
        page: 1,
        limit: 10,
        search: "",
        type: "none",
    });
    const [totalPages, setTotalPages] = useState(0);
    const [error, setError] = useState("");
    const [notificationHistories, setNotificationHistories] = useState<any[]>([]);
    const [isLoading, setIsLoading] = useState(false);
    const fetchNotificationHistories = async (page: number, type?: string) => {
        setIsLoading(true);
        setError("");
        try {
            const query = {
                ...params,
                page,
            }
            if (type) {
                query.type = type;
            }
            const response = await NotificationService.getNotificationHistories(query);
            const addDatas = response.data.notifications || [];
            setTotalPages(Math.ceil((response.data.count || 0) / params.limit));
            setNotificationHistories(addDatas);
            setIsLoading(false);
        } catch (err) {
            setError(t("Failed to fetch notification histories. Please try again later."));
            setIsLoading(false);
        } finally {
            setTimeout(() => {
                setIsLoading(false);
            }, 1000);
        }
    };

    useEffect(() => {
        fetchNotificationHistories(params.page);
    }, []);
    const handlePageChange = (page: number) => {
        setParams({
            ...params,
            page,
        });
        fetchNotificationHistories(page);
    };

    const handleTypeChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        setParams({ ...params, page: 1, type: e.target.value });
        fetchNotificationHistories(1, e.target.value);
    };

    return (
        <>
            <PageMeta
                title={t("VIYUME - VIYUME Dashboard")}
                description=""
            />
            <div className="space-y-6">
                <ComponentCard title="">
                    <div className="w-full sm:w-48">
                        <select
                            value={params.type}
                            onChange={handleTypeChange}
                            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                        >
                            <option value="none">{t("Select type")}</option>
                            <option value="All">{t("All")}</option>
                            <option value="Room">{t("Room")}</option>
                            <option value="User">{t("User")}</option>
                        </select>
                    </div>
                    <div className="mb-4 relative">
                        <Input
                            type="text"
                            placeholder={t("Search notifications") + "..."}
                            value={params.search}
                            onChange={(e) => setParams({
                                ...params,
                                page: 1,
                                limit: 10,
                                search: e.target.value
                            })}
                            onEnter={(value) => {
                                fetchNotificationHistories(params.page);
                            }}
                            className="pl-10"
                        />
                        <Search className="w-5 h-5 absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
                    </div>
                    {isLoading ? (
                        <div className="animate-pulse">
                            <div className="space-y-4">
                                {[...Array(5)].map((_, index) => (
                                    <div key={index} className="flex items-center space-x-4 py-3">
                                        <div className="h-4 bg-gray-200 rounded w-1/4"></div>
                                        <div className="h-4 bg-gray-200 rounded w-1/4"></div>
                                        <div className="h-4 bg-gray-200 rounded w-1/6"></div>
                                        <div className="h-4 bg-gray-200 rounded w-1/6"></div>
                                        <div className="h-4 bg-gray-200 rounded w-1/6"></div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    ) : error ? (
                        <div className="text-red-500 text-center p-4">{error}</div>
                    ) : (
                        <NotificationHistoryTable
                            notificationHistories={notificationHistories}
                            currentPage={params.page}
                            totalPages={totalPages}
                            onPageChange={handlePageChange}
                        />
                    )}
                </ComponentCard>
            </div>
        </>
    );
}
